import { MouseEventHandler } from "react";
import { Fa6 } from "react-icons/fa6";
import { Link } from "react-router";
import { useAppSelector } from "src/store/hooks";

export default function NavItem({
  to,
  children,
  active,
  onClick,
  Icon,
}: {
  to?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
  active?: boolean;
  Icon?: typeof Fa6;
}) {
  const { sidebarCollapsed } = useAppSelector((state) => state.context);
  const className = `flex items-center gap-4 p-4 transition-all h-14 text-base rounded-md mb-2 block ${
    sidebarCollapsed ? "w-fit" : "w-full"
  } text-left fill-neutral-gray-600  ${
    active
      ? "dark:bg-neutral-gray-700 dark:text-neutral-gray-50 dark:fill-neutral-gray-50 dark:shadow-neutral-gray-900 bg-white opacity-100 fill-primary-blue-400 text-primary-blue-400 shadow-nav font-bold"
      : "dark:hover:text-neutral-gray-100 dark:hover:fill-neutral-gray-100 dark:text-semanthics-gray-500 text-neutral-gray-600 hover:text-primary-blue-600 hover:fill-primary-blue-600"
  }`;
  return (
    <li>
      {to && (
        <Link className={className} to={to}>
          {Icon && (
            <Icon
              className={"fill-inherit"}
              // className={active ? "fill-primary-blue-400" : "fill-inherit"}
            />
          )}
          {children}
        </Link>
      )}

      {onClick && (
        <button className={className} onClick={onClick}>
          {Icon && (
            <Icon
              // className={active ? "fill-primary-blue-400" : "fill-inherit"}
              className={"fill-inherit"}
            />
          )}

          {children}
        </button>
      )}
    </li>
  );
}
